/* Arqvale — Menü-Verhalten */

// Scroll-Richtung tracken → html[data-scroll-dir="up/down"]
(function() {
  var lastY = window.scrollY;
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    document.documentElement.dataset.scrollDir = y < lastY ? 'up' : 'down';
    lastY = y;
  }, { passive: true });
})();

(function () {
  function stripHash() {
    if (location.hash) {
      history.replaceState(null, '', location.pathname + location.search);
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    /* Hinweis: Das Schließen des Burger-Menüs (inkl. Schließ-Animation und
       verzögerter Navigation) wird zentral im Inline-Script in theme.liquid
       behandelt — hier NICHT doppelt, sonst kollidieren die Handler. */

    /* Bei In-Page-Anker: nach dem Scrollen den Hash aus der URL entfernen,
       damit ein Reload nicht erneut dorthin springt */
    var href = link.getAttribute('href');
    var hashPos = href ? href.indexOf('#') : -1;
    if (hashPos !== -1) {
      var id = href.slice(hashPos + 1);
      if (id && document.getElementById(id)) {
        setTimeout(stripHash, 800);
      }
    }
  });

  /* Beim Laden mit Hash (z.B. Sprung von einer anderen Seite):
     springen lassen, dann Hash entfernen */
  window.addEventListener('load', function () {
    if (location.hash) setTimeout(stripHash, 800);
  });
})();
